import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import EmployeeDashboard from './pages/EmployeeDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AttendancePage from './pages/AttendancePage';
import LeavePage from './pages/LeavePage';
import HolidayCalendar from './pages/HolidayCalendar';
import PolicyPage from './pages/PolicyPage';
import PayslipPage from './pages/PayslipPage';
import CompensationPage from './pages/CompensationPage';
import MyApprovalsPage from './pages/MyApprovalsPage';
import OvertimePage from './pages/OvertimePage';
import SelfHelpPage from './pages/SelfHelpPage';
import ExitPortalPage from './pages/ExitPortalPage';
import PerformancePortalPage from './pages/PerformancePortalPage';
import TrainingPage from './pages/TrainingPage';
import HRPortalPage from './pages/HRPortalPage';
import HiringPortalPage from './pages/HiringPortalPage';
import PnLPortalPage from './pages/PnLPortalPage';
import PayrollPortalPage from './pages/PayrollPortalPage';
import HelpPage from './pages/HelpPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import IdleTimeout from './components/IdleTimeout';
import VersionBanner from './components/VersionBanner';
import AppFooter from './components/AppFooter';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={!user ? <Login setUser={setUser} /> : (user.role === 'admin' || user.role === 'superadmin') ? <Navigate to="/admin" /> : <Navigate to="/dashboard" />} />
          <Route path="/login" element={!user ? <Login setUser={setUser} /> : (user.role === 'admin' || user.role === 'superadmin') ? <Navigate to="/admin" /> : <Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={!user ? <Navigate to="/login" /> : (user.role === 'admin' || user.role === 'superadmin') ? <Navigate to="/admin" /> : <EmployeeDashboard user={user} setUser={setUser} />} />
          <Route path="/admin" element={!user ? <Navigate to="/login" /> : (user.role === 'admin' || user.role === 'superadmin') ? <AdminDashboard user={user} setUser={setUser} /> : <Navigate to="/dashboard" />} />
          <Route path="/attendance" element={user ? <AttendancePage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/leaves" element={user ? <LeavePage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/holidays" element={user ? <HolidayCalendar user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/policies" element={user ? <PolicyPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/payslips" element={user ? <PayslipPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/compensation" element={user ? <CompensationPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/my-approvals" element={user ? <MyApprovalsPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/overtime" element={user ? <OvertimePage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/self-help" element={user ? <SelfHelpPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/exit-portal" element={user ? <ExitPortalPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/performance" element={user ? <PerformancePortalPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/training" element={user ? <TrainingPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/hr-portal" element={user ? <HRPortalPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/hiring" element={user ? <HiringPortalPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/pnl" element={user ? <PnLPortalPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/payroll" element={user ? <PayrollPortalPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/help" element={user ? <HelpPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          <Route path="/reset-password" element={user ? <ResetPasswordPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
        </Routes>
        <IdleTimeout user={user} setUser={setUser} />
        <VersionBanner />
        {user && <AppFooter />}
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
